import moment from "moment";
import { DocumentsWithApproversTypeRecord } from "src/modules/modules.type";

import { ApprovedStatus, CodeStatus, MyWorkDocumentsType } from "src/types/main";

export async function modifiedWorkDocumentsList(data: Record<number, DocumentsWithApproversTypeRecord>) {
  let resultsObj: MyWorkDocumentsType[] = [];

  if (data && Object.keys(data).length > 0) {
    for (const [_, item] of Object.entries(data)) {
      let approversListItems = [];

      if (item.ApproversList.length > 0) {
        for (const approver of item.ApproversList) {
          let name = "", email = "";
          if (approver.Reacted) {
            name = approver.Reacted.get_lookupValue();
            email = approver.Reacted.get_email();
          } else if (approver.Author) {
            name = approver.Author.get_lookupValue();
            email = approver.Author.get_email();
          }

          let shortName = "";
          const nameArr = name && name.split(" ") || [];
          if (nameArr.length > 0) {
            nameArr.map((item: string, idx: number) => {
              if (item && idx < 2) {
                shortName += item[0];
              }
            });
          }


          approversListItems.push({
            name: `${name}`,
            avatar: null,
            approved: {
              id: +approver.Status.get_lookupId(),
              title: approver.Status.get_lookupValue() as ApprovedStatus,
            },
            shortName: `${shortName}`,
            email: email || '',
          });
        }
      }

      const obj = {
        id: item.ID,
        versionId: item.VersionID,
        code: item.Code,
        status: { title: item.Status.get_lookupValue() as CodeStatus, id: +item.Status.get_lookupId() },
        name: item.Title,
        collection: item.Collection.get_lookupValue(),
        department: item.Department.get_lookupValue(),
        type: item.DocType.get_lookupValue(),
        sentForApproval:
          item.SentForApproval && moment(item.SentForApproval).isValid()
            ? moment(item.SentForApproval).locale("ru").format("DD.MM.YYYY")
            : "",
        approversList: approversListItems,
        isReplaced: item.isReplaced,
      };

      resultsObj.push(obj);
    }
  }

  return resultsObj;
}
